// extracted by mini-css-extract-plugin
export default {"pair":"pair__dmEn1","pair__block":"pair__block__mroUY","pair__actions":"pair__actions__j55Hi"};